import AppleStoreLogo from './applestore.png'
import React from 'react'

const AppleStore = ({}) => (
  <a href="https://itunes.apple.com/us/app/frendli/id1429191944" target="_blank" rel="noopener noreferrer" className="center w-35 w-30-ns pa2 mv2 mh4">
    <img alt="AppleStore Icon" className="cta w-90" src={AppleStoreLogo}/>
  </a>
)
export default AppleStore
